
import React from 'react';
import { Tables } from '@/integrations/supabase/types';
import { format } from 'date-fns';
import { Clock, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

type Suggestion = Tables<'suggestions'>;

interface SuggestionCardProps {
  suggestion: Suggestion;
  onDelete: (id: string) => void;
}

const SuggestionCard: React.FC<SuggestionCardProps> = ({ suggestion, onDelete }) => {
  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'dd.MM.yyyy HH:mm');
    } catch (e) {
      console.error('Error formatting date:', e, dateString);
      return dateString;
    }
  };

  return (
    <div 
      key={suggestion.id} 
      className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 relative"
      data-suggestion-id={suggestion.id}
    >
      <div className="flex justify-between mb-3">
        <p className="text-sm text-gray-600 font-medium">
          Fra: {suggestion.sender_name || 'Anonym'} 
          {suggestion.sender_email && suggestion.sender_email !== 'Ingen e-post oppgitt' && 
            <span className="text-gray-500"> ({suggestion.sender_email})</span>
          }
        </p>
        <div className="flex items-center gap-2">
          <p className="text-sm text-gray-500 flex items-center">
            <Clock className="h-3 w-3 mr-1" />
            {formatDate(suggestion.created_at)}
          </p>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => onDelete(suggestion.id)}
            className="h-7 w-7 p-0 rounded-full hover:bg-red-50 hover:text-red-500"
            title="Slett tips"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <p className="text-gray-800 whitespace-pre-wrap break-words">{suggestion.message}</p>
    </div>
  );
};

export default SuggestionCard;
